import React from 'react';
import { ClassValue } from 'classnames/types';
import Typography, { TypographyProps, SupportedTagName } from '../Typography';
import styles from './PricingText.module.scss';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

type PricingTextProps<T extends SupportedTagName> = {
  size?: SupportedPricingTextSize;
} & Omit<TypographyProps<T>, 'font' | 'uppercase'>;
// Alias for backwards compatibility
export type PricingTextAttributes = PricingTextProps<SupportedTagName>;

function PricingText<T extends SupportedTagName>({
  tagName,
  size = 'lg',
  className,
  children,
  ...props
}: PricingTextProps<T>) {
  const classNames: ClassValue = [
    styles[`pricingText__size_${size.toLowerCase()}`],
    className,
  ];

  return (
    <Typography
      {...props}
      tagName={tagName as SupportedTagName} // this circumvents some weird ts problem
      className={classNames}
      font="teliasansHeading"
      uppercase
    >
      {children}
    </Typography>
  );
}

export const supportedPricingTextSizes = ['lg', 'md', 'sm', 'xs'] as const;

export type SupportedPricingTextSize = ArrayElementType<
  typeof supportedPricingTextSizes
>;

export default PricingText;
